import { Component } from '@angular/core';
import { UserResponse } from '../../models/responses/user-response';
import { getConnectedUserFromLocalStorage, resetUserInLocalStorage } from '../../utilities/user-utils';
import { MatButtonModule } from '@angular/material/button';
import { UpdateUserInfoComponent } from '../../components/settings-components/update-user-info/update-user-info.component';
import { MatDividerModule } from '@angular/material/divider';
import { PaymentPlanService } from '../../services/payment-plan.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';
import { AuthenticationService } from '../../services/authentication.service';
import { UserService } from '../../services/user.service';
import { localStoragevarNames } from '../../utilities/local-storage-utils';
import { AppComponentEventsService } from '../../events/app-component-events.service';
import { ApiKeyComponent } from '../../components/api-key/api-key.component';
import { MatDialog } from '@angular/material/dialog';
import { UploadLogoComponent } from '../../components/agency/upload-logo/upload-logo.component';
import { PaymentPlan } from '../../models/enums/payment-plan';
import { WhiteLabelService } from '../../services/white-label.service';

@Component({
  selector: 'app-user-settings-page',
  standalone: true,
  imports: [
    MatButtonModule,
    UpdateUserInfoComponent,
    ApiKeyComponent,
    MatDividerModule,
    MatProgressSpinnerModule,
    NgIf
  ],
  templateUrl: './user-settings-page.component.html',
  styleUrl: './user-settings-page.component.scss'
})
export class UserSettingsPageComponent {
  connectedUser: UserResponse = getConnectedUserFromLocalStorage();
  isLoading = false;
  hasPayed = false;
  isUserWhiteLabel = false;
  hasLogo = false;
  constructor(
    private paymentPlanService: PaymentPlanService,
    private whiteLabelService: WhiteLabelService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private userService: UserService,
    private appComponentEventService: AppComponentEventsService
  ) { }

  ngOnInit() {
    this.setHasPayed();
    this.checkWhiteLabelLogoStatus();
  }

  cancelPlan() {
    this.isLoading = true;
    this.paymentPlanService.cancelPlan().subscribe({
      next: () => {

        this.hasPayed = true;
        this.snackBar.open("Your subscription was cancelled", 'Close', { duration: 5000 });
        this.resetLoggedUser();
      },
      error: () => {
        this.isLoading = false;
        alert('Error from server contact support');
      }
    });
  }

  onAddLogo() {
    this.dialog.open(UploadLogoComponent, {
      width: '50%',
      autoFocus: false,
    }).afterClosed().subscribe(() => {
      this.hasLogo = true;
      this.resetLoggedUser();
      // this.refresUserAfterLogoActions();
    })
  }


  onDeleteLogo() {
    this.isLoading = true;
    this.whiteLabelService.deleteLogo(this.connectedUser.whiteLabelSettings!.id).subscribe({
      next: () => {
        this.snackBar.open("Your logo was cancelled", 'Close', { duration: 5000 });
        this.hasLogo = false
        this.resetLoggedUser();
        // this.refresUserAfterLogoActions();
      },
      error: () => {
        this.isLoading = false;
        alert('Error from server contact support');
      }
    });
  }

  private checkWhiteLabelLogoStatus() {
    this.hasLogo = this.connectedUser.whiteLabelSettings != undefined &&
      this.connectedUser.whiteLabelSettings.logo.length > 0;
    this.isUserWhiteLabel = this.connectedUser.paymentSettings != undefined &&
      this.connectedUser.paymentSettings.paymentPlan == PaymentPlan.WHITELABEL;

    console.log(this.hasLogo);
    console.log(this.connectedUser)
  }

  private refresUserAfterLogoActions() {
    this.resetLoggedUser();
    window.location.reload();
  }
  private resetLoggedUser() {
    this.userService.fetchLoggedUser().subscribe({
      next: (data) => {
        resetUserInLocalStorage(data)
        this.appComponentEventService.onNavRefreshEvent.emit();
        this.isLoading = false;
      },
      error: () => {
        alert('Error from server contact support');
        this.isLoading = false;
      }
    });
  }

  private setHasPayed() {
    this.hasPayed = this.connectedUser.paymentSettings ? !this.connectedUser.paymentSettings.payed : true;
  }
}
